<template>
  <v-app>
    <v-main class="grey darken-3">
      <slot />
    </v-main>

    <app-footer />
  </v-app>
</template>

<script>
import AppFooter from '../../components/app/AppFooter'

export default {
  name      : 'LoginLayout',
  components: { AppFooter },
  mixins    : [],
  data () {
    return {}
  },
  computed: {},
  watch   : {},
  created () {},
  mounted () {},
  updated () {},
  beforeDestroy () {},
  methods : {}
}

</script>

<style scoped>

</style>
